// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import router from "./router";
import store from "./store";
//echarts
import echarts from "echarts";
Vue.prototype.$echarts = echarts;
export var bus = new Vue();
Vue.prototype.$bus = bus;

import "@/assets/icons/index";
import "@/assets/css/reset.css";
import "@/assets/js/rtportal.js";
import "@/assets/css/fonts/styles.css";
import "@/assets/css/rtportal.less";

import "./assets/icons";
// 自定义组件全局注册
import components from "./components";
components.forEach((item) => Vue.component(item.name, item.component));

// 引用element-ui
import "../element-variables.scss";

/* Network plugin */
import Http from "@/plugins/http";
Vue.use(Http);

/* Auth plugin */
import Auth from "@/plugins/auth";
Vue.use(Auth);

/* Privilege plugin */
import Privilege from "@/plugins/privilege";
Vue.use(Privilege);

/* Heartbeat plugin */
import Heartbeat from "@/plugins/heartbeat";
Vue.use(Heartbeat);

import moment from "vue-moment";
Vue.use(moment);

localStorage.setItem("isStore", "1");

import vueXlsxTable from "vue-xlsx-table";
Vue.use(vueXlsxTable, {
  rABS: true,
});

//自定义组件
import PortalUI from "../packages";
Vue.use(PortalUI);

// 开启debug模式
Vue.config.debug = true;
Vue.config.productionTip = false;
// 配置是否允许vue-devtools 检查代码  默认为true
Vue.config.devtools = true;

import App from "./App";
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  template: "<App/>",
  components: {
    App,
  },
});

// import Vue from 'vue';
import xpcComponents from "vue-xpc/src/components";
import VueI18n from "vue-i18n";

//百度地图
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'xe5guek4C4X6F85aIu4qjgxq'
})

//高德地图17444b2bb086f16401f7965b00e9c675
 import GaodeMap from 'vue-amap'
 Vue.use(GaodeMap,{
   ak:'2d05c1b1d50e17e9857fbcb03a0392e2'
 });



// 使用 i18n；
Vue.use(VueI18n)
// 创建 i18n 实例
const i18n = new VueI18n();
Vue.use(xpcComponents, {
  config: {
    componentPrefix: "Rc",
    address: { autoLoad: false },
    // 默认多语言语种名称
    defaultLocale: localStorage.i18nLocale || "zh-CN",
    // 默认多语言语种 id
    defaultLocaleId: localStorage.i18nLocaleid || "2052",
    // 获取多语言语种 url
    localesUrl: "api/PortalLanguage/GetLanguageList",
    // 获取多语言语言包 url
    localesMessageUrl: "api/PortalLanguage/GetLanguageConfigs?langId=",
    // 默认无法显示图标名称
    defaultIconName: "rt-base-defaultIcon",
  },
  i18n,
});



// WEBPACK FOOTER //
// ./src/main.js